import FormElementWithPlaceholdersMixin from "../mixins/FormElementWithPlaceholdersMixin";

Vue.asyncComponent('ak-input-text-with-placeholders', {
    mixins: [FormElementWithPlaceholdersMixin],
    props: {
        type: {
            type: String,
            default: 'text'
        },
        icon: {
            type: String,
        },
        showClear: {
            type: Boolean,
        }
    }
}, 'form/controls/ak-input-text-with-placeholders.html');